/*
 * SmartScreens.ae — Klaviyo onsite loader (ensures onsite JS is present)
 * --------------------------------------------------------------------
 * If Klaviyo's onsite library has not been loaded by the theme/app, this
 * self-executing loader injects it using the store's PUBLIC company id, so
 * the track()/identify() calls below actually reach Klaviyo instead of
 * silently no-op-ing. Public company id: U8QYFx.
 */
(function(){
  if (!window.klaviyo) {
    window.klaviyo = window.klaviyo || [];
    var kobj = window.klaviyo;
    if (!Array.isArray(kobj) && typeof kobj.push !== 'function') { window.klaviyo = []; }
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://static.klaviyo.com/onsite/js/U8QYFx/klaviyo.js';
    (document.head || document.documentElement).appendChild(s);
  }
  // also seed legacy queue used by older onsite API
  window._learnq = window._learnq || [];
})();

/*
 * SmartScreens.ae — Klaviyo onsite conversion tracking
 * ----------------------------------------------------
 * Fires three lead-action events to Klaviyo via the onsite JS API:
 *   - "Clicked WhatsApp"     (any wa.me / whatsapp link or button, incl. floating FAB + popup #ssrqWa)
 *   - "Clicked Phone"        (any tel: link, anywhere)
 *   - "Submitted RFP Form"   (Request Best Price popup #ssrqForm + Request Live Demo + any contact form)
 *
 * Implementation is fully delegation-based (single document-level click + submit
 * listeners) so it captures all current AND future buttons/links/forms without
 * needing per-element wiring. Safe to load on every page; never throws if Klaviyo
 * has not finished loading.
 */
(function () {
  'use strict';

  // ---- Klaviyo push helpers (dual API: new window.klaviyo + legacy window._learnq) ----
  function track(name, props) {
    props = props || {};
    try {
      if (typeof window !== 'undefined' && window.klaviyo && typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['track', name, props]);
      }
    } catch (e) { /* swallow */ }
    try {
      if (typeof window !== 'undefined' && window._learnq && typeof window._learnq.push === 'function') {
        window._learnq.push(['track', name, props]);
      }
    } catch (e) { /* swallow */ }
  }

  function identify(traits) {
    if (!traits) return;
    try {
      if (typeof window !== 'undefined' && window.klaviyo && typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['identify', traits]);
      }
    } catch (e) { /* swallow */ }
    try {
      if (typeof window !== 'undefined' && window._learnq && typeof window._learnq.push === 'function') {
        window._learnq.push(['identify', traits]);
      }
    } catch (e) { /* swallow */ }
  }

  // ---- Context helpers ----
  function pageBase() {
    return {
      PageURL: location.href,
      PageTitle: document.title
    };
  }

  function isProductPage() {
    try {
      if (document.body && document.body.className && document.body.className.indexOf('template-product') !== -1) return true;
    } catch (e) {}
    return location.pathname.indexOf('/products/') !== -1;
  }

  function getProductTitle() {
    // 1. Shopify meta object
    try {
      if (window.meta && window.meta.product && window.meta.product.title) return window.meta.product.title;
    } catch (e) {}
    // 2. ShopifyAnalytics meta
    try {
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta &&
          window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.title) {
        return window.ShopifyAnalytics.meta.product.title;
      }
    } catch (e) {}
    // 3. data attribute hooks used by the request popup / product buttons
    try {
      var dataEl = document.querySelector('[data-ss-product]');
      if (dataEl) {
        var dp = dataEl.getAttribute('data-ss-product');
        if (dp) return dp;
      }
      var hidden = document.getElementById('ssrq_product');
      if (hidden && hidden.value) return hidden.value;
    } catch (e) {}
    // 4. On a product page, the document title is a reasonable fallback
    if (isProductPage()) {
      return (document.title || '').replace(/\s*[–\-]\s*SmartScreens\.ae\s*$/i, '').trim() || document.title;
    }
    return document.title;
  }

  // ---- WhatsApp click detection ----
  var WA_HREF_RE = /(wa\.me|api\.whatsapp\.com|whatsapp\.com\/send)/i;

  function isWhatsApp(el) {
    if (!el) return false;
    var href = (el.getAttribute && (el.getAttribute('href') || '')) || '';
    if (WA_HREF_RE.test(href)) return true;
    // class / id heuristics (floating button, in-popup button, custom buttons)
    var idAttr = (el.id || '').toLowerCase();
    var cls = (el.className && el.className.toString ? el.className.toString() : '').toLowerCase();
    if (idAttr.indexOf('whatsapp') !== -1 || idAttr === 'ssrqwa') return true;
    if (cls.indexOf('whatsapp') !== -1 || cls.indexOf('--wa') !== -1) return true;
    if (el.hasAttribute && el.hasAttribute('data-ss-wa')) return true;
    return false;
  }

  function whatsappSource(el) {
    try {
      if (el.closest && el.closest('#ssrq')) return 'Request Popup';
      if (el.closest && el.closest('.ss-fab')) return 'Global Button';
      if (el.id && el.id.toLowerCase() === 'ssrqwa') return 'Request Popup';
    } catch (e) {}
    if (isProductPage()) return 'Product Page';
    return 'Other';
  }

  // Debounce duplicate WhatsApp fires (same target firing within 800ms)
  var lastWa = { ts: 0, key: '' };
  function waDebounced(key) {
    var now = Date.now();
    if (key === lastWa.key && (now - lastWa.ts) < 800) return false;
    lastWa.ts = now;
    lastWa.key = key;
    return true;
  }

  // ---- Delegated CLICK listener: WhatsApp + Phone ----
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('a,button') : null;
    if (!el) return;

    // WhatsApp
    if (isWhatsApp(el)) {
      var src = whatsappSource(el);
      var key = src + '|' + (el.id || el.className || '');
      if (waDebounced(key)) {
        var waProps = pageBase();
        waProps.Source = src;
        if (isProductPage()) waProps.ProductTitle = getProductTitle();
        track('Clicked WhatsApp', waProps);

        // The in-popup WhatsApp button (#ssrqWa) carries the typed form data and
        // is effectively an RFP submission via WhatsApp — fire that too + identify.
        if ((el.id || '').toLowerCase() === 'ssrqwa' || (el.closest && el.closest('#ssrq'))) {
          submitFromPopup(el);
        }
      }
      return;
    }

    // Phone (tel:)
    var href = (el.getAttribute && el.getAttribute('href')) || '';
    if (href.toLowerCase().indexOf('tel:') === 0) {
      var num = href.replace(/^tel:/i, '').trim();
      var telProps = pageBase();
      telProps.Number = num;
      track('Clicked Phone', telProps);
      return;
    }
  }, true);

  // ---- Form field readers ----
  function fieldVal(form, selectors) {
    for (var i = 0; i < selectors.length; i++) {
      try {
        var el = form.querySelector(selectors[i]);
        if (el && el.value && el.value.trim()) return el.value.trim();
      } catch (e) {}
    }
    return '';
  }

  // Fire "Submitted RFP Form" (+ identify) from the in-popup WhatsApp button click,
  // reading the live form fields inside #ssrq.
  function submitFromPopup(el) {
    var popup = (el.closest && el.closest('#ssrq')) || document.getElementById('ssrq');
    if (!popup) return;
    var name = fieldVal(popup, ['#ssrq_name', '[name="contact[name]"]']);
    var email = fieldVal(popup, ['#ssrq_email', '[name="contact[email]"]']);
    var phone = fieldVal(popup, ['#ssrq_phone', '[name="contact[phone]"]']);
    var company = fieldVal(popup, ['#ssrq_company', '[name="contact[company]"]']);
    var requirement = fieldVal(popup, ['#ssrq_req', '[name="contact[body]"]']);
    var productTitle = fieldVal(popup, ['#ssrq_product', '[name="contact[product]"]']) || getProductTitle();

    var props = pageBase();
    props.ProductTitle = productTitle;
    props.Requirement = requirement;
    props.Name = name;
    props.Company = company;
    props.FormType = 'Request Best Price (WhatsApp)';
    track('Submitted RFP Form', props);

    if (email || phone) {
      var traits = {};
      if (email) traits['$email'] = email;
      if (phone) traits['$phone_number'] = phone;
      if (name) traits['$first_name'] = name;
      if (company) traits['Company'] = company;
      identify(traits);
    }
  }

  // ---- Delegated SUBMIT listener: RFP / request forms ----
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;

    var id = (form.id || '').toLowerCase();
    var isRfpPopup = (id === 'ssrqform');
    var isLiveDemo = (id === 'ssrequestlivedemoform');
    // Treat the known request forms, plus any Shopify contact form, as an RFP submission.
    var isContactForm = false;
    try {
      isContactForm = !!form.querySelector('input[name="form_type"][value="contact"], [name="contact[email]"], [name="contact[name]"]');
    } catch (err) {}

    if (!isRfpPopup && !isLiveDemo && !isContactForm) return;

    var name = fieldVal(form, ['#ssrq_name', '#SSDemoName', '[name="contact[name]"]']);
    var email = fieldVal(form, ['#ssrq_email', '#SSDemoEmail', '[name="contact[email]"]', 'input[type="email"]']);
    var phone = fieldVal(form, ['#ssrq_phone', '#SSDemoPhone', '[name="contact[phone]"]', 'input[type="tel"]']);
    var company = fieldVal(form, ['#ssrq_company', '#SSDemoCompany', '[name="contact[company]"]']);
    var requirement = fieldVal(form, ['#ssrq_req', '#SSDemoMsg', '[name="contact[body]"]', 'textarea']);
    var productTitle = fieldVal(form, ['#ssrq_product', '[name="contact[product]"]']) || getProductTitle();

    var props = pageBase();
    props.ProductTitle = productTitle;
    props.Requirement = requirement;
    props.Name = name;
    props.Company = company;
    if (isLiveDemo) props.FormType = 'Request Live Demo';
    else if (isRfpPopup) props.FormType = 'Request Best Price';
    else props.FormType = 'Contact';

    track('Submitted RFP Form', props);

    // Identify the lead as a Klaviyo profile when we have an email or phone.
    if (email || phone) {
      var traits = {};
      if (email) traits['$email'] = email;
      if (phone) traits['$phone_number'] = phone;
      if (name) traits['$first_name'] = name;
      if (company) traits['Company'] = company;
      identify(traits);
    }
  }, true);

})();
